import React from 'react'
import type { CardItemJobPositionsAndRoleProps } from './types'
import CardItemJobPositionsAndRole from './card-item-job-positions-and-role'
import { CardsContainer } from './ListJobPositionsAndRoleMyConfig.styles'
import {
  JOB_AREAS_OPTIONS_TRANSLATED,
  JOB_POSITIONS_OPTIONS_TRANSLATED
} from './constants'
import { useTranslation } from 'i18n'
import { useGetUserJobPositionsAndRolesQuery } from '__gql-generated__/types'

const ListJobPositionsAndRoleMyConfig = () => {
  const { data, loading } = useGetUserJobPositionsAndRolesQuery()
  const user = data?.me
  const { t } = useTranslation()

  const jobPositionsAndRoles: CardItemJobPositionsAndRoleProps[] = [
    {
      name: t('Cargos'),
      iconName: 'user',
      content: user?.jobPositions?.map(jobPosition => ({
        name: JOB_POSITIONS_OPTIONS_TRANSLATED[jobPosition]
      }))
    },
    {
      name: t('Área de atuação'),
      iconName: 'graduation-cap',
      content: user?.jobAreas?.map(jobArea => ({
        name: JOB_AREAS_OPTIONS_TRANSLATED[jobArea]
      }))
    },
    {
      name: t('Permissões'),
      iconName: 'settings',
      content: user?.roles?.map(role => ({
        name: role
      }))
    }
  ]

  if (loading || !user) {
    return null
  }

  return (
    <CardsContainer>
      {jobPositionsAndRoles.map(info => (
        <CardItemJobPositionsAndRole key={info.name} info={info} />
      ))}
    </CardsContainer>
  )
}

export default ListJobPositionsAndRoleMyConfig
